import React, { useRef, useState, useEffect } from "react";
import { Form } from "./Form";
import { Table } from "./Table";
import { Toast } from "primereact/toast";
import { IPermissionProps } from "../../models/Login";
import { Fetch } from "../../shared/Fetch";

export const MassMail = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ singleData: {}, open: false });
  const [tableData, setTableData] = useState<any[]>([]);
  const toast = useRef<any>(null);
  const [reload, setReload] = useState(false);

  // const loadTableData = async () => {
  //   const response = await Fetch("MassMail", "GET", null, null, toast);
  //   if (response) {
  //     const data = await response.json();
  //     setTableData(data);
  //   }
  // };

  // useEffect(() => {
  //   loadTableData();
  // }, [reload]);

  const onHideDialog = () => {
    setModal({ singleData: {}, open: false });
  };
  
  return (
    <>
      <Form open={modal.open} singleData={modal.singleData} hideDialog={onHideDialog} toast={toast} reload={reload} setReload={setReload} />

      <Table tableData={tableData} setTableData={setTableData} setModal={setModal} toast={toast} permissions={permissions} reload={reload} setReload={setReload} />

      <Toast ref={toast} />
    </>
  );
};
